import OutlinedView from './OutlinedView';

export { default as OutlinedView } from './OutlinedView';
export default OutlinedView;

export { default as DayView } from './DayView';